import { gql, useFragment } from "@apollo/client";

// Style
import style from "./posts-container.module.scss";

// Constants
import { ptSetVars } from "@/constants/gql-fields";

// Components
import PostCard from "../post-card/post-card";
import PostLoading from "../post-loading/post-loading";

export default function PostsContainer(props) {
  // Use Fragment
  const postSettings = useFragment({
    fragment: PostsContainer.fragments.posts,
    fragmentName: "PostGroupFragment",
    from: {
      __typename: props.postSettings?.__typename,
      id: props.postSettings?.id,
    },
  });

  // const eventSettings = useFragment({
  //   fragment: PostsContainer.fragments.events,
  //   fragmentName: "EventGroupFragment",
  //   from: {
  //     __typename: props.postSettings?.__typename,
  //     id: props.postSettings?.id,
  //   },
  // });

  // if (!postSettings.complete || !eventSettings.complete) {
  //   return;
  // }
  if (!postSettings.complete) {
    return;
  }

  // Variables
  let data = {};
  if (postSettings.data?.id) {
    data = postSettings.data;
  }
  // else if (eventSettings.data?.id) {
  //   data = eventSettings.data;
  // }

  const displayType = data?.[props.parent + "PostStyle"]?.[0] ?? "standard";
  const displayStyles = data.displayStyles?.[displayType + "ItemSettings"];

  const divAtts = {
    "data-display": displayType,
    "data-align": displayStyles?.itemContentAlignment ?? "left",
    "data-per-row": displayStyles?.itemsPerRow ?? 3,
  };

  // TODO: itemStyleSettings: null;

  return (
    <div className={style.posts} {...divAtts}>
      {/* <ul> */}

      {props.loading
        ? [...Array(props.numPosts)].map((_, i) => (
            <PostLoading displayType={displayType} key={i} />
          ))
        : props.posts.map((post, i) => (
            <PostCard
              post={post}
              displayType={displayType}
              settings={data}
              key={i}
            />
          ))}

      {/* </ul> */}
    </div>
  );
}

PostsContainer.fragments = {
  posts: gql`
    fragment PostGroupFragment on PosttypeSettingsACFPostGroup {
      # __typename
      # id
      # # postGroup @include(if: $isPosts) {
      # postGroup {
     ${ptSetVars}
      # }
      # eventGroup @include(if: $isEvents) {
      # eventGroup {
      #   __typename
      # }
    }
  `,
  // events: gql`
  //   fragment EventGroupFragment on PosttypeSettingsACFEventGroup {
  //     ${ptSetVars}
  //   }
  // `,
};
